import { render, staticRenderFns } from "./returnDetails.vue?vue&type=template&id=00a26e43&scoped=true"
import script from "./returnDetails.vue?vue&type=script&lang=js"
export * from "./returnDetails.vue?vue&type=script&lang=js"
import style0 from "./returnDetails.vue?vue&type=style&index=0&id=00a26e43&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a26e43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a26e43')) {
      api.createRecord('00a26e43', component.options)
    } else {
      api.reload('00a26e43', component.options)
    }
    module.hot.accept("./returnDetails.vue?vue&type=template&id=00a26e43&scoped=true", function () {
      api.rerender('00a26e43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/servicecenter/returnDetails.vue"
export default component.exports